<template>
  <div class="tab-content-presentation extensible-edit-view">
    <component
      :is="editViewComponentForSlideType"
      v-if="editViewComponentForSlideType"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import EditViewComponents from '@/components-v2/presentation-editor/side-right/EditViewComponents.js'

export default {
  computed: {
    ...mapGetters(['isPresenting']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    editViewComponentForSlideType() {
      const slideType = this.slideActive.type
      return EditViewComponents[slideType]
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-content-presentation {
  padding: 0;
  position: relative;
  z-index: 7; // https://ahaslides.atlassian.net/browse/AHA-14039
  height: 100%;
}
.edit-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
